import {
  IGetSuggestedPayRatesByGigTypeParams,
  ISuggestedPayRates,
} from '@src/models/SuggestedPayRates'
import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'
import { IPayload } from 'models/Global'

export class SuggestedPayRatesApi {
  constructor(private axios: AxiosService) {}

  getSuggestedPayRatesByGigType = async (
    params: IGetSuggestedPayRatesByGigTypeParams,
  ) => {
    const response = await this.axios.get<IPayload<ISuggestedPayRates[]>>(
      Endpoints.getSuggestedPayRatesByGigType,
      params,
    )
    return response
  }
}
